import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import {
  Tooltip,
  TooltipContent,
  TooltipPortal,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import type { Collaborator } from "./types";

const MAX_VISIBLE = 5;

interface CollaboratorAvatarsProps {
  collaborators: Collaborator[];
}

function getInitial(email: string): string {
  return email.charAt(0).toUpperCase();
}

export function CollaboratorAvatars({
  collaborators,
}: CollaboratorAvatarsProps) {
  if (collaborators.length === 0) return null;

  const visible = collaborators.slice(0, MAX_VISIBLE);
  const overflow = collaborators.slice(MAX_VISIBLE);

  return (
    <TooltipProvider delayDuration={200} disableHoverableContent>
      <div className="flex items-center -space-x-2">
        {visible.map((c) => (
          <Tooltip key={c.email}>
            <TooltipTrigger asChild>
              <Avatar className="h-7 w-7 border-2 border-background cursor-default shrink-0">
                <AvatarFallback className="text-[0.65rem] bg-secondary-100 text-secondary-600">
                  {getInitial(c.email)}
                </AvatarFallback>
              </Avatar>
            </TooltipTrigger>
            <TooltipPortal>
              <TooltipContent side="bottom" sideOffset={6} collisionPadding={8}>
                <p>{c.email}</p>
              </TooltipContent>
            </TooltipPortal>
          </Tooltip>
        ))}

        {overflow.length > 0 && (
          <Tooltip>
            <TooltipTrigger asChild>
              <Avatar className="h-7 w-7 border-2 border-background cursor-default shrink-0">
                <AvatarFallback className="text-[0.65rem] bg-secondary-200 text-secondary-700">
                  +{overflow.length}
                </AvatarFallback>
              </Avatar>
            </TooltipTrigger>
            <TooltipPortal>
              <TooltipContent
                side="bottom"
                sideOffset={6}
                collisionPadding={8}
                className="max-w-xs"
              >
                <ul className="flex flex-col gap-0.5">
                  {overflow.map((c) => (
                    <li key={c.email} className="truncate">
                      {c.email}
                    </li>
                  ))}
                </ul>
              </TooltipContent>
            </TooltipPortal>
          </Tooltip>
        )}
      </div>
    </TooltipProvider>
  );
}
